import { useEffect, useState } from 'react';

export default function GaleriaHero() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-b from-black via-gray-900 to-gray-900">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, rgba(251, 191, 36, 0.15) 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      {/* Gradient Orbs */}
      <div className="absolute top-20 left-10 w-96 h-96 bg-amber-500/10 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-yellow-500/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center pt-32 pb-20">
        {/* Badge */}
        <div 
          className={`inline-flex items-center gap-2 px-5 py-2 bg-amber-500/10 border border-amber-500/30 rounded-full mb-8 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
        >
          <i className="ri-gallery-line text-amber-400"></i>
          <span className="text-amber-400 font-medium text-sm">Galeria de Inspiração</span>
        </div>

        {/* Title */}
        <h1 
          className={`font-playfair text-6xl md:text-7xl font-bold mb-6 transition-all duration-700 delay-100 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
        >
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 via-yellow-300 to-amber-400">
            Cartas que
          </span>
          <br />
          <span className="text-white">Transformam Vidas</span>
        </h1>

        {/* Description */}
        <p 
          className={`text-xl text-gray-300 max-w-3xl mx-auto mb-12 leading-relaxed transition-all duration-700 delay-200 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
        >
          Explore cartas inspiradoras escritas por pessoas que estão transformando seus futuros. 
          Deixe-se inspirar por histórias reais de superação, gratidão e crescimento pessoal.
        </p>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {[
            { number: '2.847', label: 'Cartas Compartilhadas', delay: 'delay-300' },
            { number: '156', label: 'Categorias', delay: 'delay-400' },
            { number: '98%', label: 'Satisfação', delay: 'delay-500' }
          ].map((stat, index) => (
            <div
              key={index}
              className={`bg-white/5 backdrop-blur-sm border border-amber-500/20 rounded-2xl p-6 hover:border-amber-500/40 transition-all duration-700 ${
                stat.delay
              } ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
              }`}
            >
              <div className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-yellow-300 mb-2">
                {stat.number}
              </div>
              <div className="text-gray-400 text-sm">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Scroll Indicator */}
        <div 
          className={`mt-16 flex flex-col items-center gap-2 transition-all duration-700 delay-600 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
        >
          <span className="text-gray-400 text-sm">Role para explorar</span>
          <div className="w-6 h-10 border-2 border-amber-500/30 rounded-full flex items-start justify-center p-2">
            <div className="w-1 h-3 bg-amber-400 rounded-full animate-bounce"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
